<template>
<a-list item-layout="vertical" size="large" :pagination="pagination" :data-source="listData">
  <div id="content-footer" slot="footer">暂无更多文章…</div>
  <a-list-item slot="renderItem" key="item.title" slot-scope="item, index">
    <span slot="actions" key="read">
      <a-icon type="read" style="margin-right: 8px" />{{ item.readCount }}</span>
    <span slot="actions" v-on:click="clickLike(item.indexTitle, index)" key="like">
      <a-icon type="like" :theme="item.likeButton" style="margin-right: 8px" />{{ item.like }}</span>
    <span slot="actions" key="schedule">
      <a-icon type="clock-circle" style="margin-right: 8px" />{{ item.createTime }}</span>
    <img v-if="item.cover != ''" slot="extra" width="272" alt="logo" :src="item.cover" />
    <a-list-item-meta>
      <router-link style="font-weight:600;" slot="title" :to="item.href">{{ item.title }}</router-link>
    </a-list-item-meta>
    <div>
      <div style="margin-bottom:10px;">
        {{ item.content }}
      </div>
      <a-space size="small">
        <div v-for="text in item.tags" :key="text">
          <span slot="actions">
            <a-tag color="blue">{{ text }}</a-tag>
          </span>
        </div>
      </a-space>
    </div>
  </a-list-item>
</a-list>
</template>

<script>
import axios from 'axios';
const listData = [];

export default {
  name: 'ContentLeft',
  data() {
    return {
      listData,
      pagination: false
    };
  },
  methods: {
    clickLike(indexTitle, index) {
      if (listData[index].likeButton === 'twoTone') {
        return;
      }
      var self = this;
      axios
        .post(this.GLOBAL.host + '/passage/like/' + indexTitle)
        .then(response => {
          var res = response.data;
          if (res.code === 1000) {
            listData[index].like++;
            listData[index].likeButton = 'twoTone';
          } else {
            self.$message.error(res.message);
          }
        })
        .catch(function (error) {
          self.$notification.error({
            message: '系统异常',
            description: error
          });
        });
    }
  },
  created() {
    listData.splice(0, listData.length);
    var self = this;
    axios
      .get(self.GLOBAL.host + '/passage/list')
      .then(response => {
        var res = response.data;
        if (res.code === 1000) {
          for (var index in res.data) {
            var passage = res.data[index];
            listData.push({
              tags: passage.tags,
              like: passage.likeCount,
              readCount: passage.readCount,
              createTime: passage.createdTime,
              href: `/p/${passage.indexTitle}`,
              indexTitle: passage.indexTitle,
              title: passage.title,
              cover: passage.coverImage,
              content: passage.preview,
              likeButton: 'outlined'
            });
          }
        } else {
          self.$notification.error({
            message: '查询失败',
            description: res.message
          });
        }
      })
      .catch(function (error) {
        self.$notification.error({
          message: '系统异常',
          description: error
        });
      });
  }
};
</script>

<style scoped>
.ant-list-vertical .ant-list-item-meta {
  margin-bottom: 0px;
}

#content-footer {
  margin: 20px 0;
}
</style>
